export default __webpack_public_path__ + "static/media/header illustration.889f6603.png";